
import { Button, Form } from 'react-bootstrap';
import { organizationStore } from '../../store/OrganizationStore';
import { useSnapshot } from 'valtio';
import { FC } from 'react';
import { Organization } from '../../shared/models/organization.model';

interface OrganizationFormProps {
	updateData: any;
	organizationForm: Organization;
	updateForm: any;
}
const OrganizationForm: FC<OrganizationFormProps> = ({updateData, organizationForm, updateForm})  => {
	useSnapshot(organizationStore);
	return (
		<Form>
			{/* {isLoading && <Loader/>} */}
			<Form.Label column sm="2">Name</Form.Label>
			<Form.Control
				type="text"
				value={organizationForm.name}
				onChange={(e)=>{
					updateForm((prevState: any) => ({
						...prevState,
						name: e.target.value
						}));
				}}
			/>
			<Form.Label column sm="2">Url</Form.Label>
			<Form.Control
				type="text"
				value={organizationForm.site_url}
				onChange={(e)=>{
					updateForm((prevState: any) => ({
						...prevState,
						site_url: e.target.value
					}));
				}}
			/>
			<Form.Label column sm="2">Description</Form.Label>
			<Form.Control
				as={"textarea"}
				min={1}
				rows={3}
				value={organizationForm.description}
				onChange={(e)=>{
					updateForm((prevState: any) => ({
						...prevState,
						description: e.target.value
						}));
				}}
			/>
			<div className="d-flex justify-content-end mt-3">
				<Button onClick={updateData}>
					Update
				</Button>
			</div>
		</Form>
	);
}

export default OrganizationForm